export default function Logo({ light = false, size = 56 }) {
  const main = light ? "#ffffff" : "var(--ink)";
  const gold = "var(--gold)";
  return (
    <div className="flex items-center gap-3">
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="50"
          cy="50"
          r="46"
          stroke={main}
          strokeWidth="1.4"
          opacity="0.85"
        />
        {/* olive branch accents */}
        <path
          d="M22 30 q10 -6 18 0"
          stroke={gold}
          strokeWidth="1.6"
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M78 70 q-10 6 -18 0"
          stroke={gold}
          strokeWidth="1.6"
          fill="none"
          strokeLinecap="round"
        />
        <circle cx="26" cy="27" r="2" fill={gold} />
        <circle cx="74" cy="73" r="2" fill={gold} />
        <text
          x="50"
          y="62"
          textAnchor="middle"
          fontFamily="Cormorant Garamond, serif"
          fontSize="44"
          fontWeight="600"
          fill={main}
        >
          M
        </text>
      </svg>
      <div className="leading-none">
        <div
          className="font-display"
          style={{
            color: main,
            fontSize: "1.15rem",
            fontWeight: 600,
            letterSpacing: "0.12em",
          }}
        >
          CLEANOVA <span style={{ color: gold }}>·</span> SUD
        </div>
        <div
          style={{
            color: light ? "rgba(255,255,255,0.6)" : "var(--muted)",
            fontSize: "0.6rem",
            letterSpacing: "0.42em",
            marginTop: "3px",
          }}
        >
          GROUPE
        </div>
      </div>
    </div>
  );
}
